
//TODO transfer this to brokerSideNavConfig!

import { configs } from '../../../../constants/configs/configs';
import { SIDENAV_LINKS_TYPES } from '../constants/sideNavLinkTypes';

const {
    states : {
        GEORGIA,
        NEVADA,
        PENNSYLVANIA,
        VIRGINIA,
        NEW_MEXICO
        //NEW_JERSEY,
        //MINNESOTA,
        //IDAHO
    }
} = configs;
export const brokerNavLinksNames = {
    AGENT_INFORMATION: 'Agent Information',
    PROFILE: 'Profile',
    CERTIFICATION_STATUS: 'Certification Status',
    PARTICIPATION_INFORMATION: 'Participation Information',
    AVAILABILITY: 'Availability'
};
const brokerLinks = {
    AGENT_INFORMATION: '/hix/broker/viewcertificationinformation?ref=',
    PROFILE: '/hix/broker/viewprofile?ref=',
    CERTIFICATION_STATUS: '/hix/broker/certificationstatus?ref=',
    PARTICIPATION_INFORMATION: '/hix/broker/helpondemand/participation',
    AVAILABILITY: '/hix/broker/helpondemand/availability'
};
export const brokerNavLinks = {
    [NEVADA]: [
        {
            sectionHeader: 'Steps',
            additionalSectionHeader: 'Broker Connect',
            sectionItems: [
                {
                    name: brokerNavLinksNames.AGENT_INFORMATION,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: brokerLinks.AGENT_INFORMATION,
                    text: brokerNavLinksNames.AGENT_INFORMATION,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.PROFILE,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: brokerLinks.PROFILE,    
                    text: brokerNavLinksNames.PROFILE,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.CERTIFICATION_STATUS,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: brokerLinks.CERTIFICATION_STATUS,
                    text: brokerNavLinksNames.CERTIFICATION_STATUS,
                    visibility: true
                }
            ],
            additionalSectionItems: [
                {
                    name: brokerNavLinksNames.PARTICIPATION_INFORMATION,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: brokerLinks.PARTICIPATION_INFORMATION,
                    text: brokerNavLinksNames.PARTICIPATION_INFORMATION,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.AVAILABILITY,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: brokerLinks.AVAILABILITY,
                    text: brokerNavLinksNames.AVAILABILITY,
                    visibility: true
                }
            ]
        }
    ],
    [PENNSYLVANIA]: [
        {
            sectionHeader: 'Steps',
            additionalSectionHeader: 'Broker Connect',
            sectionItems: [
                {
                    name: brokerNavLinksNames.AGENT_INFORMATION,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: brokerLinks.AGENT_INFORMATION,
                    text: brokerNavLinksNames.AGENT_INFORMATION,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.PROFILE,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: brokerLinks.PROFILE,    
                    text: brokerNavLinksNames.PROFILE,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.CERTIFICATION_STATUS,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: brokerLinks.CERTIFICATION_STATUS,
                    text: brokerNavLinksNames.CERTIFICATION_STATUS,
                    visibility: true
                }
            ],
            additionalSectionItems: [
                {
                    name: brokerNavLinksNames.PARTICIPATION_INFORMATION,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: brokerLinks.PARTICIPATION_INFORMATION,
                    text: brokerNavLinksNames.PARTICIPATION_INFORMATION,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.AVAILABILITY,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: brokerLinks.AVAILABILITY,
                    text: brokerNavLinksNames.AVAILABILITY,
                    visibility: true
                }
            ]
        }
    ],
    [NEW_MEXICO]: [
        {
            sectionHeader: 'Steps',
            additionalSectionHeader: 'Broker Connect',
            sectionItems: [
                {
                    name: brokerNavLinksNames.AGENT_INFORMATION,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: brokerLinks.AGENT_INFORMATION,
                    text: brokerNavLinksNames.AGENT_INFORMATION,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.PROFILE,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: brokerLinks.PROFILE,
                    text: brokerNavLinksNames.PROFILE,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.CERTIFICATION_STATUS,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: brokerLinks.CERTIFICATION_STATUS,
                    text: brokerNavLinksNames.CERTIFICATION_STATUS,
                    visibility: true
                }
            ],
            additionalSectionItems: [
                {
                    name: brokerNavLinksNames.PARTICIPATION_INFORMATION,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: brokerLinks.PARTICIPATION_INFORMATION,
                    text: brokerNavLinksNames.PARTICIPATION_INFORMATION,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.AVAILABILITY,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: brokerLinks.AVAILABILITY,
                    text: brokerNavLinksNames.AVAILABILITY,
                    visibility: true
                }
            ]
        }
    ],
    [VIRGINIA]: [
        {
            sectionHeader: 'Steps',
            additionalSectionHeader: 'Agent Connect',
            sectionItems: [
                {
                    name: brokerNavLinksNames.AGENT_INFORMATION,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: brokerLinks.AGENT_INFORMATION,
                    text: brokerNavLinksNames.AGENT_INFORMATION,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.PROFILE,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: brokerLinks.PROFILE,    
                    text: brokerNavLinksNames.PROFILE,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.CERTIFICATION_STATUS,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: brokerLinks.CERTIFICATION_STATUS,
                    text: brokerNavLinksNames.CERTIFICATION_STATUS,
                    visibility: true
                }
            ],
            additionalSectionItems: [
                {
                    name: brokerNavLinksNames.PARTICIPATION_INFORMATION,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: brokerLinks.PARTICIPATION_INFORMATION,
                    text: brokerNavLinksNames.PARTICIPATION_INFORMATION,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.AVAILABILITY,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: brokerLinks.AVAILABILITY,
                    text: brokerNavLinksNames.AVAILABILITY,
                    visibility: true
                }
            ]
        }
    ],
    [GEORGIA]: [
        {
            sectionHeader: 'Steps',
            additionalSectionHeader: 'Broker Connect',
            sectionItems: [
                {
                    name: brokerNavLinksNames.AGENT_INFORMATION,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: brokerLinks.AGENT_INFORMATION,
                    text: brokerNavLinksNames.AGENT_INFORMATION,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.PROFILE,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: brokerLinks.PROFILE,    
                    text: brokerNavLinksNames.PROFILE,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.CERTIFICATION_STATUS,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: brokerLinks.CERTIFICATION_STATUS,
                    text: brokerNavLinksNames.CERTIFICATION_STATUS,
                    visibility: true
                }
            ],
            additionalSectionItems: [
                {
                    name: brokerNavLinksNames.PARTICIPATION_INFORMATION,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: brokerLinks.PARTICIPATION_INFORMATION,
                    text: brokerNavLinksNames.PARTICIPATION_INFORMATION,
                    visibility: true
                },
                {
                    name: brokerNavLinksNames.AVAILABILITY,
                    icon: null,
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: brokerLinks.AVAILABILITY,
                    text: brokerNavLinksNames.AVAILABILITY,
                    visibility: true
                }
            ]
        }
    ]
};